export type QuickAction = { label: string };

export type SuggestionCardConfig = {
  chips: string[];
  introText: string;
  quickActions: QuickAction[];
  showApplyLink?: boolean;
  tabs?: string[];
};

export const STEP_SUGGESTION_CONFIGS: Record<string, SuggestionCardConfig[]> = {
  configuration_scenario: [
    {
      chips: ["Scénario", "Prompt"],
      introText:
        "Je peux vous aider à formuler une consigne claire à partir des thèmes, événements et témoignages présents dans l'entretien.",
      quickActions: [
        { label: "Dégager les thèmes clés" },
        { label: "Suggérer un angle narratif" },
        { label: "Rédiger mon prompt" },
      ],
    },
  ],
  edition_text: [
    {
      chips: ["Scénario", "Contexte"],
      introText: "Analyse terminée. Quelques passages peuvent être renforcés.",
      quickActions: [
        { label: "Reformuler" },
        { label: "Raccourcir" },
        { label: "Dynamiser" },
      ],
      showApplyLink: true,
    },
    {
      chips: ["Édition scénario"],
      introText:
        "Analyse terminée. Votre scénario présente un rythme soutenu avec 3 montées dramatiques identifiées. Par rapport à votre choix narratif les effets les plus recommandés sont :",
      quickActions: [
        { label: "Respiration" },
        { label: "Silence" },
        { label: "Chuchotement" },
      ],
      showApplyLink: true,
    },
  ],
  choix_scenario: [
    {
      chips: ["Scénario", "Comparaison"],
      introText:
        "Trois scénarios ont été générés. Je peux vous aider à choisir celui qui correspond le mieux à votre intention.",
      quickActions: [
        { label: "Comparer les tons" },
        { label: "Identifier le plus immersif" },
        { label: "M'aider à choisir" },
      ],
    },
  ],
  scenario_edit: [
    {
      chips: [],
      introText:
        "Analyse terminée. Contexte détecté : environnement industriel. 1 son ambiant et 3 effets sonores sélectionnés pour vous.",
      quickActions: [
        { label: "Ambiance Usine" },
        { label: "Machine" },
        { label: "Clé à molette" },
        { label: "Vapeur" },
      ],
      showApplyLink: true,
      tabs: ["Sons ambiants", "Effets sonores"],
    },
  ],
};

// Ordre canonique du workflow de création d'artefact — sert à ne ré-afficher la
// carte de suggestions d'une étape QUE lorsqu'on avance (pas au retour arrière).
export const STEP_FLOW_ORDER = [
  "project_selection",
  "project_details",
  "audio_sources",
  "transcription_review",
  "configuration_scenario",
  "choix_scenario",
  "scenario_review",
  "edition_text",
  "scenario_edit",
  "final_validation",
];
